export const CLOSE_MODAL = 'CLOSE_MODAL'
export const SET_MODAL = 'SET_MODAL'
export const MINIMIZE_MODAL = 'MINIMIZE_MODAL'
export const MAXIMIZE_MODAL = 'MAXIMIZE_MODAL'
